module.exports = __webpack_public_path__ + "img/icon_s-2.2.907c7f70.svg";